import { fetcher } from '@commenda/utils';

import {
  IIndirectTaxFilingV2MutationResult,
  IIndirectTaxFilingV2StatusParams,
  IIndirectTaxFilingV2StatusResponse,
} from './types';

/**
 * POST /api/v1/new-sales-tax/filings-v2/status
 *
 * Unified breakdown + contribution status. Caller pre-splits filing IDs by
 * region; either or both arrays may be omitted, but at least one must be
 * non-empty (logical backend rejects with 400 when both are missing).
 *
 * One-shot fetch — no SWR caching. Modals call this on open + on manual
 * refresh, mirroring the legacy progress modal.
 */
export async function getIndirectTaxFilingsV2Status({
  params,
  token,
}: {
  params: IIndirectTaxFilingV2StatusParams;
  token?: string;
}): Promise<
  IIndirectTaxFilingV2MutationResult<IIndirectTaxFilingV2StatusResponse>
> {
  try {
    const response = await fetcher(
      'new-sales-tax/filings-v2/status',
      { method: 'POST', body: params },
      token
    );
    const json = await response.json();
    if (!response.ok) {
      return {
        success: false,
        error: json?.message || 'Failed to fetch filings status',
      };
    }
    return { success: true, data: json as IIndirectTaxFilingV2StatusResponse };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to fetch filings status',
    };
  }
}
